export default "__VITE_ASSET__tBzdb6GR__"